import { TypePickingRoute } from '../../interfaces/PickingRoute/TypePickingRoute'
import {
  GET_TYPE_PICKING_ROUTE,
  GET_TYPE_PICKING_ROUTE_EXITO
} from '../types/typePickingRouteActionsTypes'

export type TypePickingRouteAction =
  | TypesPickingRouteAction
  | TypesPickingRouteActionAsync

// Esto va a REDUX
export interface TypesPickingRouteAction {
  type: typeof GET_TYPE_PICKING_ROUTE_EXITO
  typesPickingRoute: TypePickingRoute[] | undefined
  error: string | undefined
}

export const getTypesPickingRouteAction = (
  typesPickingRoute?: TypePickingRoute[],
  error?: string
): TypesPickingRouteAction => {
  return {
    type: GET_TYPE_PICKING_ROUTE_EXITO,
    typesPickingRoute,
    error
  }
}

// Esto va a SAGA
export interface TypesPickingRouteActionAsync {
  type: typeof GET_TYPE_PICKING_ROUTE
}

export const getTypesPickingRouteActionAsync =
  (): TypesPickingRouteActionAsync => {
    return {
      type: GET_TYPE_PICKING_ROUTE
    }
  }
